import {Injectable} from "@angular/core";

@Injectable({providedIn: "root"})
export class SearchPickerNoResultsRenderer {

  constructor() {

  }

  createRenderer(): (query: string) => Text {
    return (query: string) => {
      return document.createTextNode("Результаты не найдены");
    };
  }

}
